import React from "react"
import PropTypes from "prop-types"
import Grid from "../../grid"
import { H2, P } from "../../typography"

const Interviews = ({ interview_summary, english_rating }) => (
  <>
    <H2 variant="primary" profile>
      Interview summary
    </H2>
    <Grid marginless gap="24px">
      {interview_summary.length > 0 ? (
        interview_summary.map((paragraph) => (
          <P variant="content" marginless profileData>
            {paragraph}
          </P>
        ))
      ) : (
        <P variant="content" marginless profileData>
          No summary available.
        </P>
      )}

      <Grid gap="4px">
        <P marginless profileLabel>
          English rating:
        </P>
        <P marginless profileData>
          {english_rating}
        </P>
      </Grid>
    </Grid>
  </>
)

Interviews.propTypes = {
  interview_summary: PropTypes.array.isRequired,
  english_rating: PropTypes.string
}

Interviews.defaultProps = {
  interview_summary: [],
  english_rating: "-"
}

export default Interviews
